import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ClientServiceCreateResponseJson } from '@vmspdb/definitions';
import * as ClientActions from './clients.actions';

export const clientsFeatureKey = 'clients';

export interface ClientState extends EntityState<ClientServiceCreateResponseJson> {
  loading: boolean;
  total: number;
  // additional entities state properties
}

export const adapter: EntityAdapter<ClientServiceCreateResponseJson> =
  createEntityAdapter<ClientServiceCreateResponseJson>({
    selectId: (model) => model.uuid || '',
  });

export const initialState: ClientState = adapter.getInitialState({
  // additional entity state properties
  total: 0,
  loading: true,
});

export const reducer = createReducer(
  initialState,
  on(ClientActions.listClients, (state) => ({
    ...state,
    loading: true,
  })),
  on(ClientActions.loadSingleClient, (state) => ({
    ...state,
    loading: true,
  })),
  on(ClientActions.listClientsFailure, (state, { error }) =>
    adapter.removeAll({ ...state, loading: false, error }),
  ),
  on(ClientActions.addClient, (state, action) =>
    adapter.addOne(action.client, state),
  ),
  on(ClientActions.upsertClient, (state, action) =>
    adapter.upsertOne(action.client, state),
  ),
  on(ClientActions.addClients, (state, action) =>
    adapter.addMany(action.clients, state),
  ),
  on(ClientActions.upsertClients, (state, action) =>
    adapter.upsertMany(action.clients, state),
  ),
  on(ClientActions.updateClient, (state, action) =>
    adapter.updateOne(action.client, state),
  ),
  on(ClientActions.updateClients, (state, action) =>
    adapter.updateMany(action.clients, state),
  ),
  on(ClientActions.deleteClient, (state, action) =>
    adapter.removeOne(action.id, state),
  ),
  on(ClientActions.deleteClients, (state, action) =>
    adapter.removeMany(action.ids, state),
  ),
  on(ClientActions.loadClients, (state, action) =>
    adapter.setAll(action.clients, state),
  ),
  on(ClientActions.clearClients, (state) => adapter.removeAll(state)),
  on(ClientActions.loadSingleClientFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const clientSelectors = adapter.getSelectors();
